import type { DiagnosticClipboardResult } from './types';

export const copyDiagnosticMarkdown = async (
  markdown: string
): Promise<DiagnosticClipboardResult> => {
  try {
    if (globalThis.navigator?.clipboard?.writeText) {
      await globalThis.navigator.clipboard.writeText(markdown);
      return { ok: true };
    }

    if (!globalThis.document?.body || typeof globalThis.document.execCommand !== 'function') {
      return { ok: false, reason: 'Clipboard is unavailable.' };
    }
    const textarea = globalThis.document.createElement('textarea');
    textarea.value = markdown;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    globalThis.document.body.appendChild(textarea);
    textarea.select();
    const copied = globalThis.document.execCommand('copy');
    textarea.remove();
    return copied ? { ok: true } : { ok: false, reason: 'Copy was not accepted.' };
  } catch {
    return { ok: false, reason: 'Copy failed.' };
  }
};
